import React from 'react';
import PropTypes from "prop-types";
import { ProductSingle } from "./ProductSingle";

export default function ProductsSlice (props) {
	const { products } = props;

	if (!products || !products.length > 0) return null;

	return (
		<section className="products">
			<div className="container">
				{products.map((singleProduct, index) => (
					<ProductSingle
						key={index}
						singlePackage={singleProduct}
						bg_colour={singleProduct.bg_colour[index].bg_colour}
					/>
				))}
			</div>
		</section>
	);
}

ProductsSlice.propTypes = {
	products: PropTypes.arrayOf(
		PropTypes.shape({
			product_payment_uid: PropTypes.string,
			id: PropTypes.string,
			name: PropTypes.string,
			price: PropTypes.string,
			price_small: PropTypes.string,
			currency_sign: PropTypes.string,
			icon: PropTypes.string,
			url: PropTypes.string,
			text_under_icon: PropTypes.string,
			text_under_price: PropTypes.string,
			is_recommedned: PropTypes.shape({
				id: PropTypes.string,
				is_recommedned: PropTypes.string
			}),
			features: PropTypes.arrayOf(
				PropTypes.shape({
					name: PropTypes.string,
					description: PropTypes.array
				})
			)
		})
	)
};


// WEBPACK FOOTER //
// src/client/components/slices/products/ProductsSlice.js